export default __webpack_public_path__ + "static/media/close-black.dd287d17.svg";